<template>
  <section class="text-white section-gradient-wrapper" :class="{ 'ol-mt-lg': haveSubgroup }">
    <div class="flex items-center no-wrap">
      <h1 v-if="titleH1" class="section__title ol-mr-auto">
        {{ title }}
      </h1>
      <span v-else class="section__title ol-mr-auto">
        {{ title }}
      </span>

      <router-link
        v-if="group && subgroup"
        :to="{ name: 'GamesByGroup', params: { group } }"
        class="section__link ol-ml-lg"
      >
        {{ $t('hide') }}
      </router-link>
    </div>
    <div v-if="selectedManufacturers.length" class="flex align-center ol-gutter-sm ol-mb-md">
      <provider-chip v-for="provider in selectedManufacturers" :key="provider.code" :provider="provider" />
    </div>
    <games-list-skeleton v-if="loadingInit" :logo-group="group" />
    <games-list
      :loading="loading"
      :games="games"
      :next="hasNextPage"
      :logo-group="group"
      :logo-subgroup="subgroup"
      @load-more="loadMore"
    />
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useGamesList } from 'src/hooks/gamesList'
import GamesList from 'components/games/GamesList'
import ProviderChip from 'components/providers/ProviderChip'
import GamesListSkeleton from 'components/games/GamesListSkeleton.vue'
import { useQuery } from '@vue/apollo-composable'
import getManufacturers from 'src/apollo/queries/getManufacturers.gql'

defineProps({
  title: {
    type: String,
    default: '',
  },
  haveSubgroup: Boolean,
  titleH1: {
    type: Boolean,
    default: false,
  },
})

const route = useRoute()

const group = computed(
  () =>
    route.params.group || route.query.group || (['GamesByManufacturer', 'Home'].includes(route.name) ? null : 'slot')
)
const subgroup = computed(() => route.params.subgroup)
const manufacturers = computed(() => route.params.manufacturer || route.query.manufacturer)

const { result: manufacturersRaw } = useQuery(getManufacturers)

const manufacturerList = computed(() => manufacturersRaw.value?.manufacturerList ?? [])
const selectedManufacturersSlugs = computed(() => (route.query.manufacturer ? route.query.manufacturer.split(',') : []))
const selectedManufacturers = computed(() =>
  manufacturerList.value.filter((el) => selectedManufacturersSlugs.value.includes(el.code.toLowerCase()))
)

const payload = computed(() => ({
  group: group.value,
  subgroup: subgroup.value,
  manufacturer: manufacturers.value,
}))
const { games, loading, hasNextPage, loadMore, loadingInit } = useGamesList(payload)
</script>
